import {Injectable} from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class CryptoService {

  constructor() { }

  encrypt(value: string, key: string): string {
    return CryptoJS.AES.encrypt(value, key.trim()).toString();
  }

  decrypt(textToDecrypt: string, key: string) {
    return CryptoJS.AES.decrypt(textToDecrypt, key.trim()).toString(CryptoJS.enc.Utf8);
  }


}
